import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import useTranslation from '@modules/hooks/useTranslation';
import { IsMobileSize } from '@modules/state/common';
import styles from './styles.module.scss';

type stepType = 1 | 2 | 3 | 4 | 5;

interface StepContentType {
    title: string;
    text: string;
}

interface Props {
    type: 'STS' | 'TTS';
}

const GuideContents = ({ type }: Props) => {
    const { t, locale } = useTranslation('guide');

    const isMobileSize = useRecoilValue(IsMobileSize);

    const [step, setStep] = useState<stepType>(1);

    const handleStepChange = (index: stepType) => setStep(index);

    return (
        <div className={styles.guide_area}>
            <ul className={styles.step_list}>
                {t('titleList')[type].map((item: string, index: number) => (
                    <li key={index} className={`${styles.step_item} ${index + 1 === step ? styles.active : ''}`}>
                        <button type="button" onClick={() => handleStepChange((index + 1) as stepType)}>
                            {index + 1}
                            <span className={styles.pc}>. {item}</span>
                        </button>
                    </li>
                ))}
                <hr
                    style={{
                        left: `${
                            !isMobileSize
                                ? `calc((100% - 160px) / 5 * ${step - 1} + ${(step - 1) * 40}px)`
                                : `calc((100% - 56px) / 5 * ${step - 1} + ${(step - 1) * 14}px)`
                        } `,
                    }}
                />
            </ul>

            <ul className={styles.content_list}>
                {t('contentList')[type].map((item: StepContentType, index: number) => (
                    <li key={index} className={`${styles.content_item} ${step === index + 1 ? styles.active : ''}`}>
                        <div className={styles.left_col}>
                            <span className={styles.step}>Step {index + 1}.</span>
                            <p className={styles.title_content}>{item.title}</p>
                            <span className={styles.text_content}>{item.text}</span>
                        </div>
                        <img src={`/images/guide/${type}/${index + 1}_${locale}.webp`} alt="" loading="eager" />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default GuideContents;
